const types = {
  SET_REGISTERED_UNEMPLOYED_PEOPLE: "SET_REGISTERED_UNEMPLOYED_PEOPLE",
  UPDATE_REGISTERED_UNEMPLOYED_PEOPLE: "UPDATE_REGISTERED_UNEMPLOYED_PEOPLE",
};

export default types;
